import React from "react";
import { packages } from "../data/packagesData";

export default function PackagesList({ limit, onPackageClick }) {
  const visible = limit ? packages.slice(0, limit) : packages;

  return (
    <div className="grid gap-12 md:grid-cols-3 sm:grid-cols-2 grid-cols-1">
      {visible.map((pkg) => (
        <div
          key={pkg.title}
          onClick={() => onPackageClick(pkg)}
          className={`cursor-pointer relative bg-white rounded-3xl border p-8 shadow-lg transition hover:shadow-2xl hover:-translate-y-1 ${
            pkg.featured
              ? "border-blue-600 ring-2 ring-blue-200"
              : "border-blue-100"
          }`}
        >
          {/* Optional Ribbon */}
          {pkg.ribbon && (
            <div className="absolute top-0 right-0 overflow-hidden w-32 h-32 pointer-events-none">
              <div
                className={`absolute -right-10 top-6 w-[200px] rotate-45 ${
                  pkg.ribbonColor || "bg-blue-700"
                } shadow-md h-6 flex items-center justify-center`}
              >
                <span className="w-full text-center text-white text-xs font-semibold leading-none">
                  {pkg.ribbon}
                </span>
              </div>
            </div>
          )}

          {/* Icon */}
          <div className="mb-6 flex justify-center">{pkg.icon}</div>

          {/* Title */}
          <h3 className="text-2xl font-semibold text-blue-900 mb-3 text-center">
            {pkg.title}
          </h3>

          {/* Positioning line */}
          {pkg.positioning && (
            <p className="text-sm text-gray-600 text-center mb-6">
              {pkg.positioning}
            </p>
          )}

          {/* Feature List */}
          <ul className="text-gray-700 text-sm space-y-3 mb-6 ml-2">
            {pkg.features.map((item, idx) => (
              <li key={idx} className="flex items-start gap-2">
                <span className="mt-1 text-blue-600">{item.icon}</span>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          {/* Notes and Detail */}
          <p className="text-sm text-gray-600 text-center mb-2">
            {pkg.note}
          </p>
          <p className="mt-2 font-medium text-blue-800 text-center">
            {pkg.detail}
          </p>
        </div>
      ))}
    </div>
  );
}
